import React from 'react';
import { toastr } from 'react-redux-toastr';

import { CustomModal } from './styles';

const ModalCloneVoicebot = ({ isActive, onClose, onSubmit, initialTitle }) => {
  const handleSubmit = (e) => {
    e.preventDefault();

    const { value } = e.target.title;

    if (!value) {
      toastr.error('Erro de validação', 'Informe o titulo do voicebot');
      return;
    }

    onSubmit({ title: value });
  };

  return (
    <CustomModal show={isActive} onHide={onClose}>
      <CustomModal.Header closeButton>
        <CustomModal.Title>Confirmar clone do Voicebot</CustomModal.Title>
      </CustomModal.Header>
      <form onSubmit={handleSubmit}>
        <CustomModal.Body>
          <div className="form-group">
            <label htmlFor="title_id">Nome do voicebot</label>
            <input
              name="title"
              id="title_id"
              defaultValue={`${initialTitle} (Clone)`}
            />
          </div>
        </CustomModal.Body>
        <CustomModal.Footer>
          <button type="submit" className="btn btn-primary">
            salvar
          </button>
        </CustomModal.Footer>
      </form>
    </CustomModal>
  );
};

export default ModalCloneVoicebot;
